export default __webpack_public_path__ + "2a3f457c7065399d79524a519e2d9bff.png";